import NavBar from './container';

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js